<script src="register.component.ts"></script>
<lib-unauthenticated-layout>
  <div title>
    <h2 class="mb-6 text-center text-2xl/9 font-bold tracking-tight text-primary-700">
      {{ 'auth.register.title' | translate }}
    </h2>
  </div>
  <div content>
    <form (ngSubmit)="onSubmitRegister()" [formGroup]="form" class="space-y-7">
      <div class="flex flex-col gap-1">
        <p-float-label>
          <input class="w-full" formControlName="name" id="name" pInputText type="text" />
          <label for="name">
            {{ 'auth.register.name' | translate }}
          </label>
        </p-float-label>
        @if (form.get('name')?.invalid && form.get('name')?.touched) {
          <small class="text-red-500">
            {{ getNameError() }}
          </small>
        }
      </div>

      <!-- email -->
      <div class="flex flex-col gap-1">
        <p-float-label>
          <input class="w-full" formControlName="email" id="email" pInputText type="email" />
          <label for="email">
            {{ 'auth.register.email' | translate }}
          </label>
        </p-float-label>
        <small
          class="text-red-500 text-xs min-h-[1rem]"
          [style.visibility]="
            form.get('email')?.invalid && form.get('email')?.touched ? 'visible' : 'hidden'
          "
          >
          {{ getEmailError() }}
        </small>
      </div>

      <!-- Password -->
      <div class="flex flex-col gap-1">
        <p-float-label>
          <p-password
            formControlName="password"
            id="password"
            toggleMask="true"
            inputStyleClass="w-full"
            styleClass="w-full block"
            [feedback]="false"
          ></p-password>
          <label for="password">
            {{ 'auth.login.password' | translate }}
          </label>
        </p-float-label>
        <small
          class="text-red-500 text-xs min-h-[1rem]"
          [style.visibility]="
            form.get('password')?.invalid && form.get('password')?.touched ? 'visible' : 'hidden'
          "
          >
          {{ getPasswordError() }}
        </small>
      </div>

      <div class="flex items-center justify-end">
        <div class="text-sm/6">
          <a
            [routerLink]="['/login']"
            class="font-semibold text-indigo-600 hover:text-indigo-500 hover:underline"
            >
            {{ 'auth.register.haveAccount' | translate }}
          </a>
        </div>
      </div>

      <div>
        <p-button [disabled]="form.invalid" styleClass="w-full font-semibold" type="submit">
          {{ 'auth.register.submit' | translate }}
        </p-button>
      </div>
    </form>
  </div>
</lib-unauthenticated-layout>
